import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import { getEventById } from "../Feed/EventsTab/Hooks/data";

import BackButton from "@/Components/Headers/Components/BackButton";
import { useRouterSearchParams } from "@/hooks/router";
import { Spacings } from "@/styling/spacings";

function ContentDetailsHeader(): React.JSX.Element {
  const eventId = useRouterSearchParams("eventId", "1");
  const event = getEventById(eventId);

  return (
    <SafeAreaView style={styles.safeArea} edges={["top"]}>
      <View style={styles.container}>
        <BackButton />
        <View style={styles.titleContainer}>
          <Text style={styles.text}>{event.title}</Text>
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    paddingHorizontal: 15,
    paddingVertical: 10,
    gap: Spacings.s2,
  },
  safeArea: {
    backgroundColor: "#fff",
  },
  text: {
    fontSize: 20,
  },
  titleContainer: {
    flex: 1,
  },
});

export default ContentDetailsHeader;
